import useTracking from "../../common/tracking/ninja/useTracking";
/**
 * Hook for tracking filter interactions using the common Ninja tracking utilities.
 * Maps the PHP filter tracking config (openEvent, changeEvent, paramName) to Ninja events.
 */
export function useFilterTracking() {
    const { trackEvent } = useTracking();
    const trackFilterOpen = (filter) => {
        var _a;
        const openEvent = (_a = filter.tracking) === null || _a === void 0 ? void 0 : _a.openEvent;
        if (!openEvent)
            return;
        trackEvent(openEvent);
    };
    const trackFilterChange = (filter, values) => {
        var _a;
        const { changeEvent, paramName } = (_a = filter.tracking) !== null && _a !== void 0 ? _a : {};
        if (!changeEvent || !paramName)
            return;
        const extraData = {
            [paramName]: values.length === 1 ? values[0] : values,
        };
        trackEvent(changeEvent, extraData);
    };
    return { trackFilterOpen, trackFilterChange };
}
